<template>
    <div @click="onItemClick(item)" @mouseenter="onItemMouseIn" @mouseleave="onItemMouseOut">
        <img :src="item.image" :alt="item.name">
        <div class="img_containerCon">
            <div class="img_containerProductName" :style="itemIntroStyle" v-show="!isItemHover">
                <div class="img_containerTxtB">{{item.name}}
                  <div v-if="shipCode && item.vrUrl" class="viewVrMiniSite" >
                    <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/vrIcon.png" alt="" title="点击进入VR全景看光谱">
                  </div>
                </div>
            </div>
            <div class="img_containerProductIntroBg" v-show="isItemHover">
                <div class="img_containerProductIntro" :style="itemIntroStyle">
                    <p class="img_containerTxtB">{{item.name}}</p>
                    <p class="img_containerTxtS">
                        {{item.description}}
                    </p>
                    <div class="button--learnMore"><button data-id="661940">了解详情&gt;</button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ExperienceItem",
    props: {
        item: {
            type: Object
        },
        onItemClick: {
            type: Function
        }
    },
    data () {
        return {
            isItemHover: false,
            isIntroShow: false
        }
    },
    methods: {
        onItemMouseIn () {
            this.isItemHover = true
            setTimeout(()=> {
                this.isIntroShow = true
            }, 100)
        },
        onItemMouseOut () {
            this.isItemHover = false
            setTimeout(()=> {
                this.isIntroShow = false
            }, 100)
        }
    },
    computed: {
          itemIntroStyle () {
              return this.isIntroShow ? { 'bottom': '15px'} : { 'bottom': '0px'}
          },
          shipCode () {
            return this.item.ships.indexOf('海洋光谱号') !== -1;
          }
      }
}
</script>

<style lang="less" scoped>
img {
    width: 100%;
}
.img_containerCon {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    bottom: 0px;
    z-index: 111;
    text-align: left;
    .img_containerProductName, .img_containerProductIntro {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 14px 20px 4px 20px;
        transition: all 0.5s ease 0s;;
    }
    .img_containerProductName {
        background: rgba(0,0,0,0.6);
    }
    .img_containerTxtB {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
    }
    .img_containerTxtS {
        color: #fff;
        font-size: 14px;
    }
    .button--learnMore {
        margin: 20px 0px 10px 0px;
        button {
            padding: 12px 18px;
            background: #FAB300;
            border-radius: 4px;
            color: #333333;
            font-size: 12px;
        }
    }
    .img_containerProductIntroBg {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.6);
    }
}
.viewVrMiniSite{
  width: 46px;
  height: 33px;
  & img{
    width: 100%;
    height: 100%;
  }
}
</style>